'use client';

import { Button } from 'components/ui/button';
import { OWNER_ROUTES } from 'utils/routes';
import { ArrowLeftIcon } from 'components/icons/v2';
import React from 'react';
import { useRouter } from 'next/navigation';

export default function BackToSigninButton() {
  const router = useRouter();
  return <Button
    type='button'
    variant='nakedGrayLink'
    className='p-0 self-center'
    onClick={() => {
      router.push(`${OWNER_ROUTES.LOGIN.getPath()}`);
    }}
  >
    <ArrowLeftIcon height={20} width={20} />
    Back to sign in
  </Button>;
}
